<template>
	<div class="container" :style="{ background: bgColor }" ref="headHeight">
		<div class="ybkLogo">
			<img @click="ybkLogo" v-show="ybkNavTrue1" src="../../public/images/home/logo.png" alt="" />
			<img @click="ybkLogo" v-show="ybkNavTrue" src="../../public/images/home/logo1.png" alt="" />
		</div>
		<div class="ybkTitle">
			<img v-show="ybkNavTrue1" src="../../public/images/home/ybkTitle.png" alt="" />
			<img v-show="ybkNavTrue" src="../../public/images/home/ybkTitle1.png" alt="" />
		</div>
		<div class="ybkNav" @mouseenter="enter" @click="navClick">
			<img v-show="ybkNavTrue1" src="../../public/images/home/before.png" alt="" />
			<img v-show="ybkNavTrue" src="../../public/images/home/after.png" alt="" />
		</div>

		<div class="navConent" :class="{ activeNav1: navTrue1, activeNav: navTrue }" v-show="ybkNavTrue">
			<div>
				<ul>
					<li>新 闻 中 心</li>
					<li v-for="item in newsList" :key="item.id" @click="newsClick">
						<a>- {{ item.name }}</a>
					</li>
				</ul>
				<ul>
					<li>成 功 案 例</li>
					<li v-for="item in caseList" :key="item.id" @click="caseClick(item.id)">
						<a>- {{ item.name }}</a>
					</li>
				</ul>
				<ul>
					<li>智 慧 商 城</li>
					<li v-for="item in goodsList" :key="item.id" @click="goodsClick(item.id)">
						<a>- {{ item.name }}</a>
					</li>
				</ul>
				<ul>
					<li>应 用 下 载</li>
					<li v-for="item in appList" :key="item.id" @click="appClick(item.id)">
						<a>- {{ item.name }}</a>
					</li>
				</ul>
				<ul>
					<li>关 于 我 们</li>
					<li v-for="item in usList" :key="item.id" @click="usClick(item.id)">
						<a>- {{ item.name }}</a>
					</li>
				</ul>
			</div>
			<p class="search">
				<input type="text" placeholder="请输入搜索内容" v-model="searchInfo" />
				<img @click="seachNews" src="../../public/images/home/search.png" alt="" />
			</p>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			searchInfo: '',
			ybkNavTrue1: true,
			ybkNavTrue: false,
			bgColor: '#fff',
			navTrue1: false,
			navTrue: false,
			newsList: [
				{
					id: 1,
					name: "公司新闻"
				},
				{
					id: 2,
					name: "行业资讯"
				}
			],
			caseList: [
				{
					id: 1,
					name: "案例展示"
				},
				{
					id: 2,
					name: "项目分布"
				},
				{
					id: 3,
					name: "我要加盟"
				}
			],
			goodsList: [
				{
					id: 1,
					name: "智能穿戴"
				},
				{
					id: 2,
					name: "紧急呼叫"
				},
				{
					id: 3,
					name: "身体辅助"
				},
				{
					id: 4,
					name: "体征测量"
				}
			],
			appList: [
				{
					id: 1,
					name: "App下载"
				},
				{
					id: 2,
					name: "关注我们"
				}
			],
			usList: [
				{
					id: 1,
					name: "公司简介"
				},
				{
					id: 2,
					name: "企业文化"
				},
				{
					id: 3,
					name: "团队风采"
				},
				{
					id: 4,
					name: "发展历程"
				},
				{
					id: 5,
					name: "荣誉硕果"
				},
				{
					id: 6,
					name: "产品展示"
				},
				{
					id: 7,
					name: "分支公司"
				},
				{
					id: 8,
					name: "加入我们"
				}
			]
		};
	},
	mounted() {
		window.sessionStorage.setItem("headHeight",this.$refs.headHeight.offsetHeight)
		this.$bus.$on('getBus', val => {
			if (val == 'scroll') {
				this.bgColor = '#fff';
				this.ybkNavTrue1 = true;
				this.ybkNavTrue = false;
				this.navTrue1 = false;
				this.navTrue = true;
			}
		});
	},
	created() {
		
	},
	methods: {
		seachNews(){
		},
		ybkLogo(){
			this.bgColor = '#fff';
			this.ybkNavTrue1 = true;
			this.ybkNavTrue = false;
			this.navTrue1 = false;
			this.navTrue = true;
			this.$router.push("/")
		},
		newsClick(){
			this.navClick()
			this.$router.push("/news")
		},
		caseClick(e){
			var that=this
			this.navClick()
			this.$router.push("/success_case")
			setTimeout(function(){
			that.$bus.$emit("getCase", e)
			},200)
			// that.$store.commit('saveIndex',e)
			if(e==3){
				this.$router.push("/join-in")
			}
		},
		goodsClick(){
			this.navClick()
		},
		appClick(e){
			var that=this
			this.navClick()
			this.$router.push("/application-download")
			setTimeout(function(){
			that.$bus.$emit("getApp", e)
			},200)
		},
		usClick(e){
			var that=this
			that.navClick()
			// window.console.log(e)
			that.$router.push("/about-us")
			setTimeout(function(){
			that.$bus.$emit("getUs", e)
			},200)
			// that.$store.commit('saveIndex',e)
		},
		navClick() {
			if (this.ybkNavTrue1 == true) {
				this.bgColor = '#2d2e33';
				this.ybkNavTrue1 = false;
				this.ybkNavTrue = true;
				this.navTrue1 = true;
				this.navTrue = false;
			} else if (this.ybkNavTrue == true) {
				this.bgColor = '#fff';
				this.ybkNavTrue1 = true;
				this.ybkNavTrue = false;
				this.navTrue1 = false;
				this.navTrue = true;
			}
		},
		enter() {
			this.bgColor = '#2d2e33';
			this.ybkNavTrue1 = false;
			this.ybkNavTrue = true;
			this.navTrue1 = true;
			this.navTrue = false;
		}
	}
};
</script>

<style scoped="scoped">
.container {
	height: 94px;
	position: relative;
	z-index: 15;
}
.ybkLogo {
	position: absolute;
	left: 28px;
	top: 50%;
	transform: translateY(-50%);
	width: 80px;
	height: 70px;
}
.ybkLogo > img {
	width: 100%;
	height: 100%;
	cursor: pointer;
}
.ybkTitle {
	position: absolute;
	top: 50%;
	left: 130px;
	width: 30%;
	height: 50px;
	transform: translateY(-50%);
}
.ybkTitle > img {
	width: 100%;
	height: 100%;
}
.ybkNav {
	position: absolute;
	right: 0;
	width: 94px;
	height: 100%;
	background: rgba(0, 0, 0, 0.6);
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
.ybkNav > img {
	width: 34px;
	height: 30px;
}

.navConent {
	position: absolute;
	width: 100%;
	top: 92px;
	bottom: calc(100vh + 92px);
	height: calc(100vh - 92px);
	background: #4c4d56;
	z-index: 4;
	background: #2d2e33;
	box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2) inset;
	overflow: hidden;
}
.navConent > div {
	padding: 66px 16%;
	display: flex;
	justify-content: space-between;
}
.navConent > div > ul {
	font-size: 21px;
	color: #e4e6e7;
}
.navConent > div > ul > li {
	padding: 8px 0;
}
.navConent > div > ul > li:first-of-type {
	font-size: 27px;
}
.navConent ul li a:hover {
	cursor: pointer;
	color: #70c2f2;
}
.activeNav1 {
	animation: activeNav1 0.6s both;
}
@keyframes activeNav1 {
	from {
		height: 0;
	}
	to {
		height: 100vh;
	}
}
.activeNav {
	animation: activeNav 0.6s both;
}
@keyframes activeNav {
	from {
		height: 100vh;
	}
	to {
		height: 0;
	}
}
.search {
	width: 50%;
	height: 54px;
	margin: 26px auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
	overflow: hidden;
	padding: 0 20px;
	border: 1.5px solid #666666;
	border-radius: 27px;
}
.search > input {
	width: 90%;
	height: 100%;
	font-size: 20px;
	outline: none;
	border: none;
	background: none;
	color: #9a9a9a;
	/* text-indent: 20px; */
}
.search > img {
	width: 32px;
	height: 32px;
	cursor: pointer;
}
</style>
